import { useTheme } from '@mui/styles';
import { Fade, LinearProgress, type Theme } from '@mui/material';
import type { LinearProgressProps } from '@mui/material/LinearProgress';

interface Props extends LinearProgressProps {
  loading?: boolean;
}

export const DelayedLinearProgress = ({ loading = true, ...props }: Props) => {
  const { loadingDelay } = useTheme<Theme>();

  return (
    <Fade style={{ transitionDelay: loadingDelay }} in={loading}>
      <LinearProgress {...props} />
    </Fade>
  );
};
